import Vue from 'vue'
import Router from 'vue-router'
import loginRoute from './modules/login'
import loginCheckRouter from './modules/loginCheck'
import taskSquareRouter from './modules/taskSquare'
import overviewRoute from './modules/overview'
import pcIntroduceRoute from './modules/pcIntroduce'
import androidIntroduceRoute from './modules/androidIntroduce'
Vue.use(Router)

const routes = [
  loginCheckRouter,
  loginRoute,
  taskSquareRouter, overviewRoute, pcIntroduceRoute, androidIntroduceRoute
]

export default new Router({
  mode: 'history', // require service support
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js